import React, { Fragment } from 'react';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import ImportantMessageBox from '../../../../messagesScreen/ImportantMessageBox';

export const VideoIncompatibilityErrorMessage = ({ isCreditCardInvestmentType }) => {
    return (
        <Fragment>
            <ConditionalToggling condition={!isCreditCardInvestmentType}>
                <ImportantMessageBox icon="alert-red" color="red-box" message="identity-videoCallBrowserNotAllowed" />
            </ConditionalToggling>
            <ConditionalToggling condition={isCreditCardInvestmentType}>
                <ImportantMessageBox
                    icon="alert-red"
                    color="red-box"
                    message="identity-videoCallBrowserNotAllowedCreditCard"
                />
            </ConditionalToggling>
        </Fragment>
    );
};
